import { render, staticRenderFns } from "./SubjectLinkModal.vue?vue&type=template&id=6c6ea6d6&"
import script from "./SubjectLinkModal.vue?vue&type=script&lang=js&"
export * from "./SubjectLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports